<template>
    <v-container fluid class="px-8">
        <div v-if="showAlert">
            <v-alert
                class="v-alert"
                v-model="showAlert"
                border="left"
                close-text="Close Alert"
                dismissible
                :type="alertType"
                style="position: absolute"
            >
                {{ alertMsg }}
            </v-alert>
        </div>
        <v-row class="ma-0 pa-0">
            <v-col cols="12">
                <v-row class="ma-0 pa-0" align="center">
                    <v-col cols="auto" class="ma-0 pa-0">
                        <span class="page-title">Email Monitoring</span>
                        <a class="page-link" href="https://portal.mimecast.com/partner/common/login" target="_blank">
                            Mimecast
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                        </a>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col v-show="$vuetify.breakpoint.mdAndUp" md="auto" class="ma-0 pa-0 px-3">
                        <DateRange 
                            :disabled="!charts_config || serviceUnavailable"
                            :start_date="start_date"
                            :end_date="end_date"
                            :min_start_date="min_start_date"
                            :max_end_date="max_end_date"
                            v-on:date_update="update_date_range"></DateRange>
                    </v-col> 
                    <v-col v-show="$vuetify.breakpoint.lgAndUp" lg="auto" class="ma-0 pa-0 px-3">
                        <span class="last_updated_title">Data Last Updated</span><br>
                        <span class="last_updated_text">{{  data_info != null ? data_info : '-' }}</span>
                    </v-col>
                    <v-col v-show="$vuetify.breakpoint.mdAndDown" cols="auto" class="ma-0 pa-0 px-3">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on">mdi-clock-outline</v-icon>
                            </template>
                            <TooltipDescription title="Data Last Updated." :desc_2="data_info != null ? data_info : '-'"></TooltipDescription>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="ma-0 py-1">
                <v-chip @click="current_page='overview'" label class="data_breakdown_chip" :outlined="current_page != 'overview'" color="primary" :disabled="!charts_config || serviceUnavailable">Overview</v-chip>
                <v-chip @click="current_page='targeted'" label class="data_breakdown_chip" :outlined="current_page != 'targeted'" color="primary" :disabled="!charts_config || serviceUnavailable || true">Top Targeted Users</v-chip>
            </v-col>
            <v-row style="width: 100%" class="ma-0 pa-0" justify="space-around">
                <v-col cols="3" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="Rejected Emails" :value="rejected_emails" :odd_box="true"></MainPageStat>
                </v-col>
                <v-col cols="3" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="Detected Emails" :value="detected_emails" :odd_box="true"></MainPageStat>
                </v-col>
            </v-row>
            <v-row style="width: 100%" class="ma-0 pa-0" justify="space-around">
                <v-col cols="2" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="Phishing Detections" :value="phishing_emails" :odd_box="true"></MainPageStat>
                </v-col>
                <v-col cols="2" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="Spam Detections" :value="spam_emails" :odd_box="true"></MainPageStat>
                </v-col>
                <v-col cols="2" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="Malware Detections" :value="malware_emails" :odd_box="true"></MainPageStat>
                </v-col>
                <v-col cols="2" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="Unwanted Detections" :value="unwanted_emails" :odd_box="true"></MainPageStat>
                </v-col>
                <v-col cols="2" class="ma-0 py-3">
                    <MainPageStat statistic_title_name="URL Clicks Detections" :value="urlclicks_emails" :odd_box="true"></MainPageStat>
                </v-col>
            </v-row>
            <v-col class="ma-0 py-1" cols="12" align="center" v-if="charts_config">
                <v-row class="ma-0 pa-0">
                    <v-col cols="5">
                        <BaseChart
                            statistic_title_name="Detections By Type"
                            :value="detections_by_type"
                            chart_type="PieChart"
                            :serviceUnavailable="serviceUnavailable"
                        >    
                        </BaseChart>
                    </v-col>
                    <v-col cols="7">
                        <BaseChart
                            statistic_title_name="Detections By Type Daily"
                            :value="detections_by_type_daily"
                            chart_type="TimeSeriesChart"
                            :serviceUnavailable="serviceUnavailable"
                        ></BaseChart>
                    </v-col>
                    <v-col cols="12">
                        <BaseChart
                            statistic_title_name="Daily Rejections"
                            :value="rejections_by_type"
                            chart_type="TimeSeriesChart"
                            :serviceUnavailable="serviceUnavailable"
                        ></BaseChart>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" align="center" v-else>
                <v-row class="ma-0 pa-0">
                    <v-col cols="5" >
                        <v-skeleton-loader type="image,image" style="height: 260px; overflow-y: hidden;"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="7">
                        <v-skeleton-loader type="image,image" style="height: 260px; overflow-y: hidden;"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12">
                        <v-skeleton-loader type="image,image" style="height: 260px; overflow-y: hidden;"></v-skeleton-loader>
                    </v-col>
                </v-row>
            </v-col>

            <!-- <v-col cols="4" align="center">
                <StatList statistic_title_name="Top Quarantined Emails" :value="quarantined_emails"></StatList>
            </v-col> -->
        </v-row>
    </v-container>
</template>

<script>
    import BaseChart from '../StatisticComponents/Charts/BaseChart.vue';
    import TooltipDescription from '../UtilityComponents/TooltipDescription.vue';
    import DateRange from '../UtilityComponents/DateRange.vue';
    import MainPageStat from '../StatisticComponents/MainPageStat.vue';
    import api_caller from "@/javascript/chart_config_retrieval.js";
    import { ALERT_GENERIC_MESSAGE, ALERT_TYPE_ERROR } from "@/constants/constants.js";

    export default {
        name: 'EmailMonitoring',
        props: [
            'start_date',
            'end_date',
            'system_min_start_date',
            'system_max_end_date'
        ],
        data: () => ({
            alertMsg: null,
            alertType: null,
            showAlert: false,
            email_data_raw: null,
            recent_alerts: [],
            threats_by_user: [],
            quarantined_emails: [],
            top_email_threats: [],

            current_page: 'overview',

            detections_by_type: null,
            detections_by_type_daily: null,
            rejections_by_type: null,

            rejected_emails: null,
            detected_emails: null,

            phishing_emails: null,
            spam_emails: null,
            malware_emails: null,
            unwanted_emails: null,
            urlclicks_emails: null,


            charts_config: null,

            data_info: null,

            serviceUnavailable: false,

            date_range: [],
            min_start_date: '2024-01-01',
            max_end_date: '2024-12-31',
            // start_date: '2024-01-01',
            // end_date: '2024-01-01'
        }),
        components: {
            MainPageStat,
            TooltipDescription,
            DateRange,
            BaseChart
        },
        mounted(){
            this.date_range = [this.start_date, this.end_date];
            this.min_start_date = this.system_min_start_date;
            this.max_end_date = this.system_max_end_date;
            this.getChartConfig()
        },
        methods: {
            update_date_range: function(date_range){
                this.date_range = date_range;
                this.min_start_date = this.system_min_start_date;
                this.max_end_date = this.system_max_end_date;
                this.$emit('system_date_update', {'start': date_range[0], 'end': date_range[1]});
                this.getChartConfig();
            },
            getChartConfig: async function () {
                this.charts_config = null;
                const token = await this.$auth.getTokenSilently();
                let charts_config = await api_caller
                    .get_email_monitoring_charts_config(token, this.date_range[0], this.date_range[1])
                    .then((resp) => {
                        if (resp["success"]) {
                            return resp["data"];
                        } else {
                            return false;
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        return false;
                    });

                if (charts_config) {
                    this.charts_config = charts_config

                    this.detections_by_type = this.charts_config['charts']['DetectionsByType']['chart_value'];
                    this.detections_by_type_daily = this.charts_config['charts']['DetectionsByTypeDaily']['chart_value'];
                    this.rejections_by_type = this.charts_config['charts']['RejectionsByTypeDaily']['chart_value'];

                    this.rejected_emails = this.charts_config['data']['RejectedEmails']['stat_value'];
                    this.detected_emails = this.charts_config['data']['DetectedEmails']['stat_value'];
                    this.phishing_emails = this.charts_config['data']['PhishingEmails']['stat_value'];
                    this.spam_emails = this.charts_config['data']['SpamEmails']['stat_value'];
                    this.malware_emails = this.charts_config['data']['MalwareEmails']['stat_value'];
                    this.unwanted_emails = this.charts_config['data']['UnwantedEmails']['stat_value'];
                    this.urlclicks_emails = this.charts_config['data']['URLClicksEmails']['stat_value'];

                    this.data_info = this.charts_config['data_info']['data_last_updated'];
                    if(this.data_info == null){
                        this.serviceUnavailable = true;
                    }

                } else {
                    this.triggerAlert(ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
                }
            },
            triggerAlert: function (type, message) {
                this.alertType = type ? type : "info";
                this.alertMsg = message;
                this.showAlert = true;
            },
        }
    }
</script>

<style scoped>
    .last_updated_title{
        font-family: "Gothic Bold" !important;
        font-size: 0.8em !important;
    }
    .last_updated_text{
        font-family: "Gothic" !important;
        font-size: 0.85em !important;
    }
    .page-title{
        font-family: "Gothic Bold" !important;
        font-size: 25pt !important;
    }
    .page-link{
        font-family: "Gothic" !important;
        font-size: 15pt !important;
        margin-left: 10px;
        color: #020446;
    }
    .data_breakdown_chip {
        font-family: "Gothic Bold" !important;
        /* color: black !important; */
        font-weight: 600;
        width: 175px;
        justify-content: center;
        margin-left: 1px;
        margin-right: 1px;
    }
    .theme--light.v-chip {
        color: white;
    }
</style>